import React, {useState} from 'react';
import {Typography} from '@mui/material';
import {Filters} from '@vedmarket/ui-kit';
import {useTranslation} from 'react-i18next';

const NotificationsFilters = ({options, onApply}: NotificationsFiltersProps) => {
  const {t} = useTranslation();

  const [ selectedSections, setSelectedSections ] = useState<string[]>([]);

  return (
    <Filters
      applyButtonText={t('actions__text__applyFilters')}
      onApply={(values) => onApply(values.sections as string[])}
      onChange={(values) => {
        setSelectedSections(values.sections as string[]);
      }}
      sections={[
        {
          key: 'sections',
          title: t('notifications__text__section'),
          defaultValues: [],
          selectedValues: selectedSections,
          options: options.map((option) => ({
            value: option.value,
            label: <Typography variant='body1'>{option.label}</Typography>,
          })),
        },
      ]}
    />
  );
};

export default NotificationsFilters;
